import { useEffect, useContext } from "react";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { LanguageContext } from "../../context/LanguageContext";
import { COLORS } from "theme/tokens";

function Footer({ company, links }) {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
  useEffect(() => {
    loadLanguageFile("footer", "footer/footer_lang");
  }, [language, loadLanguageFile]);
  const LANGUAGE = componentLanguageData.footer || { Main: {} };

  const companyName = (company && company.name) || LANGUAGE.Main.Content1 || "MAS";

  // 2026-05-25 改為部落格法務頁（Sean 提供 4 連結）
  const defaultLinks = [
    { href: "https://masquant.com/", name: LANGUAGE.Main.Content7 || "回到官方網站" },
    { href: "https://masquant.com/使用者條款/", name: LANGUAGE.Main.Content2 || "使用者條款" },
    { href: "https://masquant.com/隱私權政策-gdpr/", name: LANGUAGE.Main.Content3 || "隱私權政策 / GDPR" },
    { href: "https://masquant.com/風險揭露條款", name: LANGUAGE.Main.Content4 || "風險揭露提示" },
    { href: "https://masquant.com/cookie-policy/", name: LANGUAGE.Main.Content6 || "Cookie 政策" },
  ];
  const computedLinks = Array.isArray(links) && links.length > 0 ? links : defaultLinks;

  return (
    <MDBox
      component="footer"
      width="100%"
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      justifyContent="space-between"
      alignItems="center"
      gap={1}
      px={{ xs: 2, md: 4 }}
      py={1.5}
      sx={{
        backgroundColor: COLORS.white,
        borderTop: "1px solid",
        borderColor: "grey.200",
      }}
    >
      <MDTypography variant="caption" color="text" sx={{ fontSize: 12 }}>
        {`MAS © ${new Date().getFullYear()} by ${companyName}`}
      </MDTypography>

      <MDBox display="flex" gap={3}>
        {computedLinks.map((link) => (
          <a
            key={link.name}
            href={link.href}
            target="_blank"
            rel="noreferrer"
            className="auth-underline"
            style={{
              color: COLORS.main,
              fontSize: 12,
              fontWeight: 500,
            }}
          >
            {link.name}
          </a>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default Footer;
